import fetch from '@/api/fetch.js'

export function initInterest (params) {
  return fetch({
    url: '/planBook/interest/pbInit',
    params
  })
}

export function getInterestDetail (params) {
  return fetch({
    url: '/planBook/interest/detail',
    method: 'post',
    data: params
  })
}

export function saveShareInteraction (params) {
  return fetch({
    url: '/planBook/result/shareSave',
    method: 'post',
    data: params
  })
}

export function getPolicyDetailInfo (params) {
  return fetch({
    url: '/planBook/insurePlan/v2/result/detailInfo',
    method: 'post',
    data: params
  })
}

export function getInterestDetailWithRemark (params) {
  return fetch({
    url: '/planBook/interest/detailWithRemark',
    method: 'post',
    data: params
  })
}

export function saveUserSettingByPlanbookId (planbookId, params) {
  return fetch({
    url: `/planBook/result/${planbookId}/saveUserSetting`,
    method: 'post',
    data: params
  })
}